import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCalender5"><Path d="M15.5 3H8.5V4.25C8.5 4.66421 8.16421 5 7.75 5C7.33579 5 7 4.66421 7 4.25V3H3.75C3.33579 3 3 3.33579 3 3.75V7.5H21V3.75C21 3.33579 20.6642 3 20.25 3H17V4.25C17 4.66421 16.6642 5 16.25 5C15.8358 5 15.5 4.66421 15.5 4.25V3Z" fill="currentColor"/><Path d="M21 9H3V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalender5;
